import {
  createReceiver,
} from '@resource/resource'

const MODEL_PJAX = 'product-ajax/'

const PRODUCT_PJAX_URL = `/${MODEL_PJAX}{label}/{?filter_template}`

export const productPjaxResource = createReceiver(PRODUCT_PJAX_URL)
